/**
 * .select-all
 * Bind event to select all
 *
 * @package:  Betta
 * @version:  2.2
 * @author:   Cyrill N KALITA
 */

import checkAll from '@github/check-all';

;(function($) {

    "use strict";

    $(function(){

        /**
         * Select all, as property, to b able to bind it later
         */
        let selectAll = function (){
            /**
             * Find all containers
             */
            let checkAllContainer = document.querySelector('[data-check-all-container]');
            /**
             * if a container found, attach the action
             */
            if (checkAllContainer) {
                checkAll(checkAllContainer);
            }
        };

        /**
         * Append even to any input within document
         */
        $(document).ready(selectAll)

    });
})(window.jQuery);
